import { formatMobileNumber } from "../../utils/Helpers";

export const CLIENT_PROFILE_EMPTY_VALUE = "-";

export const formatClientId = (id) =>
  id != null ? `#CLT-${String(id).padStart(3, "0")}` : CLIENT_PROFILE_EMPTY_VALUE;

export const formatClientPhone = (client) => {
  const dialCode = client?.country?.dial_code ?? client?.dial_code;
  const formatted = formatMobileNumber(client?.phone_number, dialCode);
  return formatted || CLIENT_PROFILE_EMPTY_VALUE;
};
